// Selectors over the user's accessible accounts. Two stores can hold the
// account record we need for breadcrumbs:
//
//   1. `state.user.metadata.accounts[]` — the user's *switchable* accounts
//      (drives the topbar switcher). Populated at login. For a DS user
//      this often does NOT include child accounts the DS only manages.
//   2. `state.accounts.accounts[]` — the DS-managed children list,
//      populated once the user visits the Accounts list page.
//
// `selectAccountByUuid` checks both, since a DS editing a child account
// usually arrives via the Accounts list (so #2 is hot) but a deep link
// reload may have only #1 available before the list re-fetches.
const findInList = (list, uuid) =>
  Array.isArray(list) ? list.find(a => a && a.uuid === uuid) || null : null;

/**
 * Find an account by uuid across both metadata and the DS-managed list.
 * Returns the raw account object or null. Used by breadcrumb labels for
 * routes that edit a specific child account (DS context).
 */
export const selectAccountByUuid = (state, uuid) => {
  if (!uuid) return null;
  return (
    findInList(state.user?.metadata?.accounts, uuid) ||
    findInList(state.accounts?.accounts, uuid) ||
    findInList([state.accountEditing?.editedAccount], uuid) ||
    null
  );
};
